import script from "./SiteNotify.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteNotify.vue?vue&type=script&setup=true&lang=ts"

import "./SiteNotify.vue?vue&type=style&index=0&id=f92ada14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f92ada14"]])

export default __exports__